import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
// import { AccountContext } from '../Accounts'
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLogo,
  NavMenu,
  NavBtn,
  NavBtnLink,
  NavLogoContainer
} from './NavbarElements';

const Navbar = ({ toggle, isHeader = false }) => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogoContainer>
              <NavLogo $scrollNav={scrollNav} onClick={toggleHome} to='/'>
                Stories We Feel
              </NavLogo>
            </NavLogoContainer>
            {isHeader ?
              (
                <>
                  <MobileIcon onClick={toggle}>
                    <FaBars />
                  </MobileIcon>
                  <NavMenu></NavMenu>
                </>
              ) :
              <>
                <MobileIcon onClick={toggle}>
                  <FaBars />
                </MobileIcon>
                <NavMenu>
                  <NavItem>
                    <NavLinks
                      to='about'
                      $scrollNav={scrollNav}
                      smooth={true}
                      duration={500}
                      spy={true}
                      exact='true'
                      offset={-80}
                    >
                      About
                    </NavLinks>
                  </NavItem>
                  {/* <NavItem>
                <NavLinks
                  to='discussion'
                  scrollNav={scrollNav}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Discussion
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='GetStarted'
                  scrollNav={scrollNav}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Get Started
                </NavLinks>
              </NavItem> */}
                </NavMenu>
              </>
            }
            {/* <NavBtn>
              <NavBtnLink to='/cashcrew'>Crew Builder</NavBtnLink>
            </NavBtn> */}
            <NavBtn>
              <NavBtnLink to={'/account'}>Account</NavBtnLink>
            </NavBtn>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
